let pendingUUID: string | null = null;

export const setPendingUploadUUID = (uuid: string | null) => {
  pendingUUID = uuid;
};

export const getPendingUploadUUID = () => pendingUUID;
